export default __webpack_public_path__ + "static/media/product_NPC_PC_Cn.7c5c7bea.webp";